module.exports = __webpack_public_path__ + "static/cliente_2-830e6647c566b7ad705577f71b2fa707.png";